import { render, staticRenderFns } from "./BannerUpdateForm.vue?vue&type=template&id=5c0a3b12&"
import script from "./BannerUpdateForm.vue?vue&type=script&lang=js&"
export * from "./BannerUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports